import React from "react";
import MainPageContainer from "../../../components/MainPageContainer";

const LoadMapIndex = () => {
  return (
    <>
      <div className="gas-page-container">
        <MainPageContainer className="!w-full">
          {" "}
          <iframe
            src="https://jvvnl-dash.gna.energy/"
            style={{
              width: "100%",
              height: "100vh",
              border: "none",
              borderRadius: "12px",
            }}
            title="JVVNL Load Map"
          />
        </MainPageContainer>{" "}
      </div>
    </>
  );
};

export default LoadMapIndex;
